export function isVoluti() {
    const email = sessionStorage.getItem('emailUser')?.toString();
    const volutiEmails = [
      'financeiro@highersolucoes.com',
      'faleconosco@vemdepremios.com.br',
    ];
  
    return false;
}